import buildRequestUrl from "lib/requests/requestUtils";
import athenaClient from "lib/axios/clients";

export default async function getCycles(filters = {}) {
  const config = {
    method: "GET",
    url: buildRequestUrl(filters, "cycles"),
  };

  const response = await athenaClient(config);
  return response.data;
}

export async function getCyclestype(filters = {}) {
  const config = {
    method: "GET",
    url: buildRequestUrl(filters, "cycle_types"),
  };

  const response = await athenaClient(config);
  return response.data;
}
